import "./styles/globals.css";
import "./styles/variables.css";

import { useEffect } from "react";

import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Home from "./pages/Home";
import SupportProject from "./pages/SupportProject";
import PaymentPage from "./pages/PaymentPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import DiscordClaimResult from "./pages/DiscordClaimResult";
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import PressKit from "./pages/PressKit";

import { trackPageView, trackScrollDepth } from "./analytics/analytics";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/analytics")) {
      return;
    }

    trackPageView();

    const trackedDepths = new Set();

    function handleScroll() {
      const scrollTop =
        window.scrollY || document.documentElement.scrollTop || 0;

      const documentHeight =
        document.documentElement.scrollHeight - window.innerHeight;

      if (documentHeight <= 0) {
        return;
      }

      const percent = Math.round((scrollTop / documentHeight) * 100);
      const depths = [25, 50, 75, 90];

      for (const depth of depths) {
        if (percent >= depth && !trackedDepths.has(depth)) {
          trackedDepths.add(depth);
          trackScrollDepth(depth);
        }
      }
    }

    window.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AnalyticsTracker />

      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/support" element={<SupportProject />} />

        <Route path="/payment" element={<PaymentPage />} />

        <Route path="/payment-success" element={<PaymentSuccess />} />

        <Route path="/discord-claim-result" element={<DiscordClaimResult />} />

        <Route path="/analytics" element={<AnalyticsDashboard />} />

        <Route path="/press" element={<PressKit />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
